import React from 'react';

type IconProps = {
  className?: string;
};

/**
 * Icono "minimize" (Lucide `minimize`, ISC) — las cuatro esquinas plegándose
 * hacia dentro, par exacto de MaximizeIcon: mismo lienzo y mismo grosor de
 * trazo, así que el botón no "salta" al cambiar de estado.
 */
export const MinimizeIcon = ({ className }: IconProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M8 3v3a2 2 0 0 1-2 2H3" />
      <path d="M21 8h-3a2 2 0 0 1-2-2V3" />
      <path d="M3 16h3a2 2 0 0 1 2 2v3" />
      <path d="M16 21v-3a2 2 0 0 1 2-2h3" />
    </svg>
  );
};
